var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "seo-edit-container" },
    [
      _c(
        "AModal",
        {
          attrs: {
            actions: _vm.modalActions,
            title: "SEO Settings",
            size: "lg",
            "disable-portaling": "",
          },
          model: {
            value: _vm.showModal,
            callback: function ($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal",
          },
        },
        [
          _c("seo-field-edit", {
            model: {
              value: _vm.seo,
              callback: function ($$v) {
                _vm.seo = $$v
              },
              expression: "seo",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }